export default {
  payWelfareText: 'Zalety doładowania',
  blackFridayDiscount: 'Zniżka czasowa z okazji Black Friday',
  shareGift: 'Podziel się prezentem',
  vipWeeklyWelfare: 'Tygodniowa zniżka VIP',
  exchangeCoupon: 'Kupon',
  firstPayOff: 'Do 15% zniżki na pierwszy zakup',
  blackFridayEvent: 'Wydarzenie Black Friday',
  limitedTimeOff: 'Ograniczona czasowo zniżka 10%',
  claimCoupon: 'Odbierz teraz',
  blackFridayTimedCoupon: 'Kupon czasowy Black Friday',
  timeLeft: 'Pozostały czas: ',
  claimTimeCoupon: 'Odbierz kupon 10% zniżki już teraz!',
  points: 'Punkty: ${point}',
  costPointTip: 'Wymieniaj punkty na kupony',
  maxPointTip: 'Każde konto może wykorzystać do 500 punktów.',
  discountOff: '10% zniżki',
  highestDiscount: 'Do ${discount} zniżki',
  needPoint: 'Wymaga ${point} pkt',
  changeCurrency: 'Zmień walutę',
  claim: 'Odbierz',
  claimSucc: 'Odebrano',
  claimFail: 'Porażka',
  pointNotEnough: 'Za mało punktów',
  afterClaimPoint: 'Pozostałe punkty: ${point}',
  footTips1: 'Do każdego zamówienia można wykorzystać tylko 1 kupon.',
  footTips2: 'Kuponu nie można wykorzystać do zakupu walut/tokenów w grze.',
  footTips3:
    ' Zastrzegamy sobie prawo do ostatecznej interpretacji tego wydarzenia.',
  ruleTitleText: 'Zasady wydarzenia',
  ruleTime:
    'Czas trwania wydarzenia: 00:00 24 listopada 2023 r. do 23:59 26 listopada 2023 r. (UTC)',
  bfRuleText1:
    '1. 400 punktów zostanie przyznanych na konto użytkownika po pierwszym zalogowaniu się na oficjalnej stronie doładowania podczas wydarzenia. Można wymienić do 500 punktów na kupony.',
  bfRuleText2:
    '2. Punkty Black Friday można wymieniać na kupony podczas wydarzenia.',
  bfRuleText3:
    '3. Do każdego zamówienia można użyć tylko 1 kuponu. Kuponów nie można wykorzystać do zakupu walut/tokenów w grze.',
  bfRuleText4: '4. W przypadku transakcji akceptujemy tylko następujące waluty:',
  ableCoinsType: '/',
  bfRuleText5:
    '5. Nie można zmienić waluty po dokonaniu transakcji. Wymienione punkty nie podlegają zwrotowi.',
  bfRuleText6: '6. Kupony Black Friday są ważne tylko przez 7 dni.',
  bfRuleText7:
    '7. Zastrzegamy sobie prawo do ostatecznej interpretacji tego wydarzenia.',
  thanksTip:
    'Dziękujemy za udział. Dołącz do naszej oficjalnej społeczności, aby uzyskać więcej informacji o wydarzeniu.',
  exchangePoints: 'Wymień',
  exchangeCode: 'Wpisz kod wymiany.',
  enterExchangeCode: 'Wpisz kod wymiany.',
  exchangeText: 'Wymień',
  confirmGet: 'Potwierdź',
  couponUsedWay:
    'Kupon można wykorzystać tylko w określonych walutach, prosimy o potwierdzenie waluty.',
  confirmText: 'Potwierdź',
  exchangeSucc: 'Wymieniono',
  aboutCoins: 'Informacje o walutach/tokenach w grze',
  aboutCoinsText:
    'Waluty/tokeny w grze można wymieniać na wszystkie pakiety i przywileje z wyjątkiem samej waluty/tokena w grze.',
  known: 'OK',
  codeText: 'Kod',
  codeInvalid: 'Nieprawidłowy kod!',
  hasExchanged: 'Nie można ubiegać się o więcej kodów.',
  hideText: 'Ukryj',
  //黑五的报错码
  'bf-20001': 'Niezalogowany',
  'bf-20002': 'Błąd parametru. Spróbuj ponownie wziąć udział w wydarzeniu.',
  'bf-20003': 'Za mało punktów',
  'bf-20004':
    'Nie udało się! Spróbuj ponownie później lub skontaktuj się z działem obsługi klienta.',
  'bf-20005': 'Odebrano',
  'bf-20015': 'Wydarzenie jest obecnie niedostępne.',
  'bf-20016': 'Wydarzenie się zakończyło.',
  bfShareText: 'Odbierz kupon 10% zniżki już teraz!',
  rightsCenterBtn: 'Centrum członków premium',
  payBtn: 'Płatność',
  hasEqualRewardMuglo: 'Up to 1800 Diamonds BONUS from official website top-up!',
  productInterceptPopupTitle: 'Purchase Failed',
  productInterceptPopupTip: 'This item is not available in your region.<br>Please contact customer support if you have any questions.',
  productInterceptPopupConfirm: 'OK',
  vipHeadAwardText285 : 'Glorious Extraordinaire (Permanent)',
  rightCenterNoticeTitle: 'System Punktów VIP zostaje przekształcony w Centrum Przywilejów',
  rightCenterNoticeContent: "Witamy, Dowódco!<br />Dziękujemy za Twoje nieustające wsparcie. Aby zapewnić Ci jeszcze lepsze doświadczenia związane z nagrodami, obecny System Punktów VIP zostanie zaktualizowany do nowego Centrum Przywilejów dnia 26 czerwca 2025 roku. Nowy system nie tylko połączy dotychczasowe korzyści VIP, ale również wprowadzi wiele ekscytujących, nowych udogodnień. Oto, co warto wiedzieć:<br />1. Co się zmienia?<br />Cotygodniowe korzyści za logowanie wciąż dostępne<br />Od 26 czerwca do 9 lipca 2025 r. gracze nadal będą mogli odbierać cotygodniowe Kupony VIP, logując się na Oficjalnej Stronie Doładowań. Liczba kuponów pozostanie taka sama jak w dotychczasowym wydarzeniu Punktów VIP. Równocześnie, w Centrum Przywilejów będzie można odbierać nowe kupony, z uwzględnieniem maksymalnego limitu zniżek. Szczegółowe zasady dotyczące nowych kuponów i limitów wymiany znajdują się w tabeli na końcu tego ogłoszenia.<br />Uwaga: funkcję automatycznego odbioru kuponów należy aktywować ręcznie. Przejdź do: Strona główna Centrum Przywilejów > Korzyści dla członków > Automatyczne odbieranie kuponów > Wybierz kupony do automatycznego odbioru > Potwierdź.<br />Nowa funkcja wymiany punktów<br />Centrum Przywilejów udostępni funkcję wymiany punktów. Punkty będzie można zdobywać logując się do gry lub wykonując określone zadania, a następnie wymieniać je na ekskluzywne kupony, rzadkie przedmioty i inne cenne nagrody. (Szczegóły i limity wymiany znajdziesz na stronie Centrum Przywilejów.)<br />Dziedziczenie poziomu VIP<br />Twój obecny poziom VIP oraz zgromadzone Punkty VIP zostaną w pełni przeniesione do nowego systemu. Otrzymasz automatycznie odpowiedni poziom w Centrum Przywilejów, a wszystkie dotychczasowe korzyści VIP zostaną zachowane - a nawet ulepszone.<br />2. Dlaczego ta zmiana jest lepsza<br />Bardziej przejrzyste korzyści: Wszystkie zasady dotyczące nagród oraz szczegóły wymiany są jasno przedstawione, dzięki czemu łatwiej niż kiedykolwiek możesz odebrać swoje korzyści.<br />Więcej nagród: Czekają na Ciebie nowe wydarzenia wymiany punktów oraz regularnie aktualizowane, wartościowe przedmioty.<br />Losowania nagród: Oprócz wymiany punktów, dostępne będą także wydarzenia z losowaniami, które dadzą Ci szansę na zdobycie cennych przedmiotów w grze.<br />3. Ważne informacje<br />W okresie przejściowym (26 czerwca – 9 lipca 2025 r.) sekcja Punktów VIP będzie stopniowo wycofywana. Nadal będzie można odbierać i wykorzystywać kupony jak dotychczas. Pamiętaj, aby wykorzystać wszystkie pozostałe kupony przed zakończeniem Wydarzenia Punktów VIP - niewykorzystane kupony wygasną po jego zamknięciu.<br />Po uruchomieniu Centrum Przywilejów, uzyskasz do niego dostęp wchodząc na: Oficjalne Centrum Doładowań > Stuknij w swój awatar > Centrum Przywilejów",
  rightCenterNoticeTableTitle: 'Porównanie zmian kuponów',
  rightCenterNoticeTableHeader1: 'Wymagania dotyczące realizacji - Poziom członkostwa Premium',
  rightCenterNoticeTableHeader2: 'Oryginalny Poziom VIP',
  rightCenterNoticeTableHeader3: 'Zniżka na kupon',
  rightCenterNoticeTableHeader4: 'Limit zakupu',
  rightCenterNoticeTableHeader5: 'Limit maks. zniżki',
  rightCenterNoticeTableLevel1: 'Brąz',
  rightCenterNoticeTableLevel2: 'Srebro', 
  rightCenterNoticeTableLevel3: 'Złoto',
  rightCenterNoticeTableLevel4: 'Platyna',
  rightCenterNoticeTableLevel5: 'Diament',
  rightCenterNoticeTableCount1: 'Raz dziennie',
  rightCenterNoticeTableCount2: '15 razy / miesiąc',
  rightCenterNoticeTableCount3: '10 razy / miesiąc',
  rightCenterNoticeTableLimit: '$15',
  rightCenterNoticeTableTip: 'Uwaga: Limity zniżek kuponów w Centrum Przywilejów są oparte na USD i mogą się zmieniać wraz z kursem wymiany walut. Rzeczywista kwota zniżki zostanie wyświetlona na stronie użycia.',
  '-': '-'
};
